module.exports = __webpack_public_path__ + "static/media/12UNCTAD19.76a76ff0.jpg";